const NATIVE_TYPES = [
    typeof Date !== 'undefined' ? Date : null,
    typeof Event !== 'undefined' ? Event : null,
    typeof RegExp !== 'undefined' ? RegExp : null,
    typeof WeakMap !== 'undefined' ? WeakMap : null,
    typeof WeakSet !== 'undefined' ? WeakSet : null,
    typeof Error !== 'undefined' ? Error : null,
    typeof Blob !== 'undefined' ? Blob : null,
    typeof Buffer !== 'undefined' ? Buffer : null,
    typeof ArrayBuffer !== 'undefined' ? ArrayBuffer : null,
].filter(Boolean);

/**
 * Check if the object it's a native object
 * Native Object: Object that cannot be converted to a pure object.
 *
 * @param object
 * @returns {*}
 */
export function isNativeObject(object: any): boolean {
    return (
        NATIVE_TYPES.filter((nativeObject) => object instanceof (nativeObject as any) || object === nativeObject)
            .length > 0
    );
}
